// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3xtQc","rootSuccess":"CompleteLink_rootSuccess__1HwfE","rootFailure":"CompleteLink_rootFailure__1l-jC","isDisabled":"CompleteLink_isDisabled__vHN8P"};